import { Link } from '@remix-run/react'
import { Card, CardBody, CardSubtitle, CardTitle } from 'reactstrap'

import { type Spotlight } from '#app/models/content.server.ts'

export type SpotlightCardProps = {
  item: Spotlight
  detailHref?: string
  /** When false, entire card is not a link (e.g. inside a carousel that wraps the slide). */
  linkable?: boolean
  className?: string
}

export function SpotlightCard({
  item,
  detailHref,
  linkable = true,
  className = '',
}: SpotlightCardProps) {
  const href = detailHref ?? `/novidades/${encodeURIComponent(item.slug)}`

  const inner = (
    <>
      <div className="spotlight-card-image-wrap ratio ratio-16x9 overflow-hidden rounded-top">
        <img
          src={item.bannerImageUrl}
          alt=""
          className="object-fit-cover w-100 h-100"
          loading="lazy"
        />
      </div>
      <CardBody className="d-flex flex-column flex-grow-1">
        <CardTitle tag="h3" className="section-title-grid text-primary fw-bold h5" style={{ fontSize: '18px' }}>
          {item.title}
        </CardTitle>
        <CardSubtitle tag="p" className="section-subtitle-grid text-black flex-grow-1 mb-3" style={{ fontSize: '14px' }}>
          {item.summary}
        </CardSubtitle>
        <span className="text-primary fw-semibold text-uppercase">
          Ler matéria
        </span>
      </CardBody>
    </>
  )

  if (!linkable) {
    return (
      <Card className={`spotlight-card border-0 shadow-sm h-100 overflow-hidden ${className}`}>
        {inner}
      </Card>
    )
  }

  return (
    <Link
      to={href}
      className={`text-decoration-none text-reset d-block h-100 ${className}`}
    >
      <Card className="spotlight-card border-0 shadow-sm h-100 overflow-hidden spotlight-card--link">
        {inner}
      </Card>
    </Link>
  )
}
